import { AvatarImage } from "@/components/ui/avatar";
import { useSignedUrl } from "@/lib/storageUrls";

/**
 * Drop-in AvatarImage whose src may be a storage path, a legacy public
 * bucket URL, or an external URL (admin-pasted). Renders nothing while the
 * signed URL resolves — the surrounding <Avatar>'s fallback (initials)
 * shows instead, exactly like a slow image load.
 */
export function SignedAvatarImage({
  src,
  alt = "",
}: {
  src: string | null | undefined;
  alt?: string;
}) {
  const url = useSignedUrl("avatars", src);
  if (!url) return null;
  // crossOrigin makes the response non-opaque (Supabase storage sends
  // Access-Control-Allow-Origin: *) so the service worker can actually cache
  // it — workbox CacheFirst refuses opaque (status 0) responses.
  return <AvatarImage src={url} alt={alt} crossOrigin="anonymous" />;
}
